import { Box, Container } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
// import { useForm } from "react-hook-form";
import { useParams, useNavigate } from 'react-router-dom'
import CustomButton from '../../../../../Components/CustomButton/CustomButton'
// import { Input } from "../../../../../Components/Input";
import { makeGetRequest, makePostRequest } from '../../../../../utils/api'
import urls from '../../../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
// import ComboBox from '../../../../../Components/ComboBox'
import EditOperationForm from './EditOperationForm'
// import SupprimerOperationForm from './SupprimerOperationForm'

export const DetailDepense = () => {
  const { id } = useParams()

  const [operations, setOperations] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [selected, setSelected] = useState(false)
  const [vname, setVName] = useState('')

  // const [selectedSupprimer, setSelectedSupprimer] = useState(false)

  useEffect(() => {
    fetchVehicleDetail()
    // fetchOperations();
  }, [])

  const fetchVehicleDetail = async () => {
    const response = await makeGetRequest(urls.crudVehiclesOperations + id, {}, true)
    if (response.status === 200) {
      // setVehicule(response.data)
      let output = response.data

      let name = output.Name
      setVName(name)
      let url = `${urls.crudVehiclesFsiOperations}`
      const response1 = await makeGetRequest(url + '?SousCategorieID=' + output.category, {}, true)
      if (response1.status === 200) {
        setOperations({ ...response1.data })
        // setLoading( false );
      }
    }
  }

  const fetchOperations = async (pagination = '') => {
    setLoading(true)

    // if ( pagination !== "" ) //general=true&
    // {
    //   url += pagination;
    // }
    let url = `${urls.crudVehiclesFsiOperations}`
    const response = await makeGetRequest(url + '?SousCategorie=' + vname, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkOperationsM,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
      }
    }
  }

  return (
    <>
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            <CreateOperationForm setOperations={setOperations} />
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  // formRef.current.handleClickOpen(true)
                  setSelectedRowsParams({
                    ...operations.results.filter((v) => v.id === selectedRows[0]),
                  })
                  setSelected(true)
                } else {
                  setSelected(false)
                  alert('Please Select one document for modifier')
                }
              }}
            >
              Modifier
            </CustomButton>
            {selected ? (
              <EditOperationForm
                setOperations={setOperations}
                setSelected={setSelected}
                params={selectedRowsParams}
                operations={operations}
              />
            ) : (
              ''
            )}
            {/* supprimer */}
            {/* <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  // formRef.current.handleClickOpen(true)
                  setSelectedRowsParams({...operations.results.filter((v) => v.id === selectedRows[0])})
                  // setSelectedSupprimer(true)
                
                } else {
                  // setSelectedSupprimer(false)
                  alert('Please Select one document for supprimer')
                }
              }}
            >
              supprimer
            </CustomButton> */}
            {/* {selectedSupprimer ? (

              <SupprimerOperationForm
                      setOperations={setOperations}
                      setSelected={setSelected}
                      params={selectedRowsParams}
                      operations={operations}
                      
                    />
            ):(
              ''
            )} */}

            <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
          </Box>
        </Box>

        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
    </>
  )
}
